'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var produce = require('immer');
var effects = require('redux-saga/effects');
var networkMiddleware = require('@piconetworks/network-middleware');
var endpoints = require('@piconetworks/endpoints');
var menuMiddleware = require('@piconetworks/menu-middleware');
var qs = require('qs');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var qs__default = /*#__PURE__*/_interopDefaultLegacy(qs);

var types = ['LOGIN', 'LOGIN_SUCCESS', 'LOGIN_ERROR', 'SOCIAL_LOGIN', 'SOCIAL_LOGIN_SUCCESS', 'SOCIAL_LOGIN_ERROR', 'LOGOUT', 'LOGOUT_SUCCESS', 'LOGOUT_ERROR', 'USE_REFRESH_TOKEN', 'USE_REFRESH_TOKEN_SUCCESS', 'USE_REFRESH_TOKEN_ERROR', 'TOKEN_LOGIN', 'TOKEN_LOGIN_SUCCESS', 'TOKEN_LOGIN_ERROR', 'CLAIM_MAGIC_LINK', 'CLAIM_MAGIC_LINK_SUCCESS', 'CLAIM_MAGIC_LINK_ERROR', 'REGISTER_CONFIRM', 'REGISTER_CONFIRM_SUCCESS', 'REGISTER_CONFIRM_ERROR'];

var creators = function creators(duck) {
  return {
    login: function login(payload) {
      return Object.assign({
        type: duck.types.LOGIN
      }, payload);
    },
    logout: function logout(payload) {
      return Object.assign({
        type: duck.types.LOGOUT
      }, payload);
    },
    useRefreshToken: function useRefreshToken() {
      return {
        type: duck.types.USE_REFRESH_TOKEN
      };
    },
    tokenLogin: function tokenLogin(payload) {
      return Object.assign({
        type: duck.types.TOKEN_LOGIN
      }, payload);
    },
    socialLogin: function socialLogin(payload) {
      return Object.assign({
        type: duck.types.SOCIAL_LOGIN
      }, payload);
    },
    claimMagicLink: function claimMagicLink(payload) {
      return {
        type: duck.types.CLAIM_MAGIC_LINK,
        payload: payload
      };
    },
    registerConfirm: function registerConfirm(payload) {
      return {
        type: duck.types.REGISTER_CONFIRM,
        payload: payload
      };
    }
  };
};

var initialState = {
  claim: null,
  isAuthed: false,
  error: null,
  redirectUrl: null
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.LOGIN:
        draftState.error = duck.initialState.error;
        break;

      case duck.types.LOGIN_ERROR:
        draftState.error = error;
        break;

      case duck.types.SOCIAL_LOGIN:
        draftState.error = duck.initialState.error;
        break;

      case duck.types.SOCIAL_LOGIN_ERROR:
        draftState.error = error;
        break;

      case duck.types.LOGOUT:
        draftState.error = duck.initialState.error;
        break;

      case duck.types.LOGOUT_SUCCESS:
        draftState.isAuthed = false;
        draftState.error = duck.initialState.error;
        break;

      case duck.types.TOKEN_LOGIN:
        draftState.isAuthed = duck.initialState.isAuthed;
        draftState.error = duck.initialState.error;
        break;

      case duck.types.TOKEN_LOGIN_SUCCESS:
        draftState.isAuthed = true;
        draftState.error = duck.initialState.error;
        break;

      case duck.types.TOKEN_LOGIN_ERROR:
        draftState.isAuthed = false;
        draftState.error = error;
        break;

      case duck.types.CLAIM_MAGIC_LINK:
        draftState.claim = payload.claim;
        break;

      case duck.types.CLAIM_MAGIC_LINK_SUCCESS:
        draftState.claim = duck.initialState.claim;
        break;

      case duck.types.CLAIM_MAGIC_LINK_ERROR:
        draftState.claim = duck.initialState.claim;
        draftState.error = error;
        console.error(error);
        break;

      case duck.types.REGISTER_CONFIRM_SUCCESS:
        draftState.redirectUrl = payload.redirectUrl;
        break;

      case duck.types.REGISTER_CONFIRM_ERROR:
        draftState.redirectUrl = false;
        break;

    }
  });
};

function* claimMagicLink(_ref) {
  var types = _ref.types,
      creators = _ref.creators,
      payload = _ref.payload;
  var url;

  if (payload.scope === 'publisher') {
    url = endpoints.OAUTH_PUBLISHER_LINK();
  } else {
    url = endpoints.OAUTH_USER_LOGIN();
  }

  try {
    if (!payload.claim) {
      throw Error('token claim is required');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'get',
        baseURL: endpoints.PICO_API_URL(),
        url: url,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        params: {
          token_claim: payload.claim
        },
        timeout: 30000
      }
    }),
        data = _yield$putResolve.data;

    yield effects.putResolve(creators.tokenLogin({
      accessToken: data.token,
      refreshToken: data.refresh_token
    }));
    yield effects.put({
      type: types.CLAIM_MAGIC_LINK_SUCCESS,
      payload: {
        accessToken: data.token,
        refreshToken: data.refresh_token
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.CLAIM_MAGIC_LINK_ERROR,
      error: error.message
    });
  }
}

function* login(_ref) {
  var types = _ref.types,
      creators = _ref.creators,
      email = _ref.email,
      password = _ref.password,
      publisherId = _ref.publisher_id;

  try {
    if (!email) {
      throw Error('email must be provided');
    }

    if (!password) {
      throw Error('password must be provided');
    }

    if (!publisherId) {
      throw Error('publisher id must be provided');
    }

    var _yield$putResolve = yield effects.putResolve({
      type: networkMiddleware.GET_TOKEN,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.OAUTH_USER_LOGIN(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        timeout: 30000,
        data: {
          email: email,
          password: password,
          publisher_id: publisherId
        }
      }
    }),
        data = _yield$putResolve.data;

    if (data) {
      yield effects.putResolve(creators.tokenLogin({
        accessToken: data.token,
        refreshToken: data.refresh_token
      }));
    }

    yield effects.put({
      type: types.LOGIN_SUCCESS,
      payload: Object.assign({}, data)
    });
  } catch (error) {
    var errorResponseMessage = error.response && error.response.data && error.response.data.message;
    yield effects.put({
      type: types.LOGIN_ERROR,
      error: errorResponseMessage || error.message
    });
  }
}

function* logout(_ref) {
  var types = _ref.types,
      publisherId = _ref.publisherId,
      tokenKey = _ref.tokenKey,
      _ref$withNetworkReque = _ref.withNetworkRequest,
      withNetworkRequest = _ref$withNetworkReque === void 0 ? true : _ref$withNetworkReque;

  try {
    var state = yield effects.select();
    yield effects.put({
      type: menuMiddleware.RESET
    });

    if (withNetworkRequest) {
      yield effects.putResolve({
        type: networkMiddleware.REQUEST,
        config: {
          method: 'delete',
          baseURL: endpoints.PICO_API_URL(),
          url: endpoints.OAUTH_USER(),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            refreshtoken: state._network.refresh_token[tokenKey],
            publisherid: publisherId
          },
          timeout: 30000
        }
      });
    }

    yield effects.putResolve({
      type: networkMiddleware.REMOVE_TOKENS
    });
    yield effects.put({
      type: types.LOGOUT_SUCCESS,
      payload: {
        response: {}
      }
    });
  } catch (error) {
    yield effects.putResolve({
      type: networkMiddleware.REMOVE_TOKENS
    });
    yield effects.put({
      type: types.LOGOUT_ERROR,
      error: error.message
    });
  }
}

function* socialLogin(_ref) {
  var types = _ref.types,
      creators = _ref.creators,
      error = _ref.error,
      accessToken = _ref.accessToken,
      refreshToken = _ref.refreshToken;

  try {
    if (error) {
      throw new Error(error);
    }

    yield effects.putResolve(creators.tokenLogin({
      accessToken: accessToken,
      refreshToken: refreshToken
    }));
    yield effects.put({
      type: types.SOCIAL_LOGIN_SUCCESS,
      payload: {
        accessToken: accessToken,
        refreshToken: refreshToken
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.SOCIAL_LOGIN_ERROR,
      error: error.message
    });
  }
}

function* tokenLogin(_ref) {
  var types = _ref.types,
      accessToken = _ref.accessToken,
      refreshToken = _ref.refreshToken;

  try {
    if (!accessToken) {
      throw Error('access token is required for token login');
    }

    if (!refreshToken) {
      throw Error('refresh token is required for token login');
    }

    yield effects.putResolve({
      type: networkMiddleware.STORE_TOKENS,
      access_token: accessToken,
      refresh_token: refreshToken
    });
    yield effects.put({
      type: types.TOKEN_LOGIN_SUCCESS,
      payload: {
        accessToken: accessToken,
        refreshToken: refreshToken
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.TOKEN_LOGIN_ERROR,
      error: error.message
    });
  }
}

function* useRefreshToken(_ref) {
  var types = _ref.types;

  try {
    yield effects.putResolve({
      type: networkMiddleware.REFRESH_TOKEN
    });
    yield effects.put({
      type: types.USE_REFRESH_TOKEN_SUCCESS,
      payload: {
        response: {}
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.USE_REFRESH_TOKEN_ERROR,
      error: error.message
    });
  }
}

function* registerConfirm(_ref) {
  var _ref$payload = _ref.payload,
      email = _ref$payload.email,
      publisherId = _ref$payload.publisherId,
      verification = _ref$payload.verification,
      types = _ref.types;

  try {
    var response = yield effects.putResolve({
      type: networkMiddleware.REQUEST,
      config: {
        method: 'post',
        baseURL: endpoints.PICO_API_URL(),
        url: endpoints.USERS_REGISTER_CONFIRM(),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          publisherid: publisherId
        },
        timeout: 30000,
        data: {
          email: email,
          newsletter_ids: [],
          publisherId: publisherId,
          verification: verification
        }
      }
    });

    if (!response.data) {
      throw new Error('no response data');
    }

    if (response.data.error) {
      throw new Error(response.error);
    }

    if (!response.data.redirect_url) {
      throw new Error('no redirect_url');
    }

    var redirectUrl = response.data.redirect_url;
    var splitRedirectUrl = redirectUrl.split('?');

    if (!splitRedirectUrl[1]) {
      throw new Error("unable to split redirect URL ".concat(redirectUrl));
    }

    var parsedRedirectUrl = qs__default['default'].parse(splitRedirectUrl[1]);

    if (!parsedRedirectUrl.pico_access_token || !parsedRedirectUrl.pico_refresh_token) {
      throw new Error("unable to parse redirect URL: ".concat(parsedRedirectUrl));
    }

    yield effects.putResolve({
      type: networkMiddleware.STORE_TOKENS,
      access_token: parsedRedirectUrl.pico_access_token,
      refresh_token: parsedRedirectUrl.pico_refresh_token
    });
    yield effects.put({
      type: types.REGISTER_CONFIRM_SUCCESS,
      payload: {
        redirectUrl: redirectUrl,
        accessToken: parsedRedirectUrl.pico_access_token,
        refreshToken: parsedRedirectUrl.pico_refresh_token
      }
    });
  } catch (error) {
    yield effects.put({
      type: types.REGISTER_CONFIRM_ERROR,
      error: error.message
    });
  } //   try {
  //     if (!accessToken) {
  //       throw Error('access token is required for token login');
  //     }
  //     if (!refreshToken) {
  //       throw Error('refresh token is required for token login');
  //     }
  //     yield putResolve({
  //       type: STORE_TOKENS,
  //       access_token: accessToken,
  //       refresh_token: refreshToken,
  //     });
  //     yield put({
  //       type: types.TOKEN_LOGIN_SUCCESS,
  //       payload: {
  //         response: {},
  //       },
  //     });
  //   } catch (error) {
  //     yield put({
  //       type: types.TOKEN_LOGIN_ERROR,
  //       error,
  //     });
  //   }

}

var sagas = function sagas(duck) {
  return {
    claimMagicLink: function* claimMagicLink$1(payload) {
      yield claimMagicLink(Object.assign({}, payload, duck));
    },
    login: function* login$1(payload) {
      yield login(Object.assign({}, payload, duck));
    },
    logout: function* logout$1(payload) {
      yield logout(Object.assign({}, payload, duck));
    },
    socialLogin: function* socialLogin$1(payload) {
      yield socialLogin(Object.assign({}, payload, duck));
    },
    tokenLogin: function* tokenLogin$1(payload) {
      yield tokenLogin(Object.assign({}, payload, duck));
    },
    useRefreshToken: function* useRefreshToken$1(payload) {
      yield useRefreshToken(Object.assign({}, payload, duck));
    },
    registerConfirm: function* registerConfirm$1(payload) {
      yield registerConfirm(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.LOGIN, sagas.login), effects.takeEvery(types.LOGOUT, sagas.logout), effects.takeEvery(types.USE_REFRESH_TOKEN, sagas.useRefreshToken), effects.takeLatest(types.TOKEN_LOGIN, sagas.tokenLogin), effects.takeLatest(types.SOCIAL_LOGIN, sagas.socialLogin), effects.takeLatest(types.CLAIM_MAGIC_LINK, sagas.claimMagicLink), effects.takeLatest(types.REGISTER_CONFIRM, sagas.registerConfirm)];
};

var storeDefault = 'auth';
var index = (function (_ref) {
  var _ref$store = _ref.store,
      store = _ref$store === void 0 ? storeDefault : _ref$store,
      createDuck = _ref.createDuck,
      _ref$initialState = _ref.initialState,
      initialState$1 = _ref$initialState === void 0 ? initialState : _ref$initialState,
      _ref$creators = _ref.creators,
      creators$1 = _ref$creators === void 0 ? creators : _ref$creators,
      _ref$types = _ref.types,
      types$1 = _ref$types === void 0 ? types : _ref$types,
      _ref$reducer = _ref.reducer,
      reducer$1 = _ref$reducer === void 0 ? reducer : _ref$reducer,
      _ref$sagas = _ref.sagas,
      sagas$1 = _ref$sagas === void 0 ? sagas : _ref$sagas,
      _ref$takes = _ref.takes,
      takes$1 = _ref$takes === void 0 ? takes : _ref$takes,
      selectors = _ref.selectors;
  return createDuck({
    store: store,
    initialState: initialState$1
  }).extend({
    creators: creators$1,
    types: types$1,
    reducer: reducer$1,
    sagas: sagas$1,
    takes: takes$1,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = storeDefault;
exports.takes = takes;
exports.types = types;
